import React from 'react';
import PropTypes from 'prop-types';

// BugZero card header — the styleguide replacement for the old Falcon
// CardHeader. Renders a clean light header bar (token-driven) at the top of a
// Card: title on the left, optional actions on the right. API-compatible with
// the legacy FalconCardHeader (title / titleTag / titleClass / className /
// children) so it's a drop-in swap.
const BzCardHeader = ({ title, titleTag: TitleTag = 'h5', titleClass, className, light, children }) => (
  <div
    className={className}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      padding: '14px 18px',
      borderBottom: '1px solid var(--line-soft)',
      background: light ? 'var(--bg-soft)' : 'transparent'
    }}
  >
    <TitleTag
      className={titleClass}
      style={{
        margin: 0,
        fontSize: 'var(--fs-lg)',
        fontWeight: 600,
        color: 'var(--ink)',
        lineHeight: 1.3
      }}
    >
      {title}
    </TitleTag>
    {children && (
      <div className="bz-row" style={{ gap: 8 }}>
        {children}
      </div>
    )}
  </div>
);

BzCardHeader.propTypes = {
  title: PropTypes.node,
  titleTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  titleClass: PropTypes.string,
  className: PropTypes.string,
  light: PropTypes.bool,
  children: PropTypes.node
};

export default BzCardHeader;
